// Dashboard corporate palette and style constants
// Extracted from AdminIATab.tsx — single source of truth for dashboard visuals

export const C = {
  azul1: '#1F3864',
  azul2: '#2F5496',
  azulMedio: '#6BA3D4',
  azulClaro: '#A8C8E8',
  azulSuave: '#D6E4F0',
  azulMuyOscuro: '#0E243E',
  grisOscuro: '#595959',
  grisMedio: '#D9D9D9',
  grisClaro: '#F2F2F2',
  blanco: '#FFFFFF',
};

export const DASH_KPI_CARD: React.CSSProperties = {
  background: C.blanco,
  border: `0.5px solid ${C.grisMedio}`,
  borderTop: `2.5px solid ${C.azul1}`,
  borderRadius: 8,
  padding: '20px 18px',
};

export const DASH_CONTENT_CARD: React.CSSProperties = {
  background: C.blanco,
  border: `0.5px solid ${C.grisMedio}`,
  borderTop: `2.5px solid ${C.azul1}`,
  borderRadius: 8,
  padding: '18px 20px',
  display: 'flex',
  flexDirection: 'column',
};

export const DASH_CARD_TITLE: React.CSSProperties = {
  fontSize: 11,
  fontWeight: 700,
  color: C.azul1,
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  marginBottom: 14,
  margin: 0,
};
